__turbopack_context__.v({
  "box": "THIQtq_box",
  "corner": "THIQtq_corner",
  "dim": "THIQtq_dim",
  "fading": "THIQtq_fading",
  "land": "THIQtq_land",
  "landed": "THIQtq_landed",
  "layer": "THIQtq_layer",
  "lead": "THIQtq_lead",
  "more": "THIQtq_more",
  "moreButton": "THIQtq_moreButton",
  "muted": "THIQtq_muted",
  "placed": "THIQtq_placed",
});
